
import { EnrichedVisitor } from "@/types/database";
import { toast } from "sonner";

/**
 * Exports selected visitors data to a CSV file
 */
export const exportVisitorsToCSV = (visitors: EnrichedVisitor[], selectedVisitorIds: Set<string>) => {
  if (!visitors || selectedVisitorIds.size === 0) {
    toast.error("Please select leads to export");
    return;
  }

  const selectedVisitorsData = visitors.filter(visitor => selectedVisitorIds.has(visitor.id));
  
  if (selectedVisitorsData.length === 0) {
    toast.error("No leads selected for export");
    return;
  }

  const headers = [
    "Company",
    "Industry", 
    "Size",
    "Location",
    "Visit Time",
    "Person Name",
    "Job Title",
    "Email",
    "Work Email",
    "Mobile Phone",
    "LinkedIn Profile",
    "Confidence"
  ];

  const csvData = selectedVisitorsData.map(visitor => [
    visitor.company_name || '',
    visitor.company_industry || '',
    visitor.company_size || '',
    `${visitor.location_locality || ''}, ${visitor.location_country || ''}`,
    new Date(visitor.created_at).toLocaleDateString(),
    visitor.person_name || visitor.person_data?.full_name || '',
    visitor.person_job_title || visitor.person_data?.job_title || '',
    visitor.recommended_personal_email || (visitor.personal_emails || [])[0] || '',
    visitor.work_email || '',
    visitor.mobile_phone || '',
    visitor.company_linkedin_url || '',
    visitor.company_confidence || ''
  ]);

  const csvContent = [
    headers.join(','),
    ...csvData.map(row => row.map(cell => `"${cell}"`).join(','))
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `leads_export_${new Date().toISOString().split('T')[0]}.csv`;
  link.click();
  
  toast.success(`${selectedVisitorsData.length} leads exported successfully`);
};
